module.exports = __webpack_public_path__ + "static/media/googlePlay.617c2a55.png";